import React, { ReactNode } from "react";
import { PhoneStatusBar } from "./PhoneStatusBar";
import { PhoneHomeIndicator } from "./PhoneHomeIndicator";
import { cn } from "../../lib/utils";

interface PhoneFrameProps {
  children: ReactNode;
  showStatusBar?: boolean;
  showHomeIndicator?: boolean;
  className?: string;
  contentClassName?: string;
}

export const PhoneFrame = ({
  children,
  showStatusBar = true,
  showHomeIndicator = true,
  className,
  contentClassName,
}: PhoneFrameProps) => (
  <div
    data-testid="phone-frame"
    className={cn(
      "h-[700px] w-[350px] rounded-[36px] border-2 border-border bg-white",
      className,
    )}
    style={{
      aspectRatio: "350 / 757",
    }}
  >
    <div className="flex h-full w-full flex-col overflow-hidden rounded-[34px] bg-white">
      {showStatusBar && <PhoneStatusBar />}
      <div className={cn("flex-1 overflow-y-auto p-4 pt-8", contentClassName)}>
        {children}
      </div>
      {showHomeIndicator && <PhoneHomeIndicator />}
    </div>
  </div>
);
